<template>
  <WebsiteCmsShell title="Edit Kategori Berita" subtitle="Perbarui pengelompokan publikasi website" list-eyebrow="Ubah data" list-title="Form kategori" list-description="Perbarui informasi kategori lalu simpan perubahan.">
    <template #list><Form v-if="dataLoaded" :form="form" :route="'website-post-categories/' + form.id" /></template>
  </WebsiteCmsShell>
</template>

<script>

import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue"
import Form from "@/component/websites/PostCategoryForm.vue";
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    WebsiteCmsShell,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: "",
        description: "",
      },
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('website-post-categories/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/website/post-category')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Kategori Berita", route: "/website/post-category" },
      { title: "Edit Kategori Berita" },
    ])
    // Get Data
    this.get()
  },

}

</script>
